import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-score-picker',
  templateUrl: './score-picker.component.html',
  styleUrls: ['./score-picker.component.scss'],
})
export class ScorePickerComponent implements OnDestroy {
  @Input() brandName: string;
  score: number;
  types = [
    { key: 'VERYGOOD', value: '', stars: 5 },
    { key: 'GOOD', value: '', stars: 4 },
    { key: 'FAIR', value: '', stars: 3 },
    { key: 'BAD', value: '', stars: 2 },
    { key: 'VERYBAD', value: '', stars: 1 }
  ];

  destroyed$ = new Subject<boolean>();
  loading$: Observable<boolean>;

  translations: any;

  constructor(private router: Router, private modalCtrl: ModalController, private translate: TranslateService) {
    this.translate
    .get(['SCORE_MODULE'])
    .pipe(takeUntil(this.destroyed$))
    .subscribe((t: any) => {
      this.types[0].value = t.SCORE_MODULE.SCORE_TYPES.VERYGOOD;
      this.types[1].value = t.SCORE_MODULE.SCORE_TYPES.GOOD;
      this.types[2].value = t.SCORE_MODULE.SCORE_TYPES.FAIR;
      this.types[3].value = t.SCORE_MODULE.SCORE_TYPES.BAD;
      this.types[4].value = t.SCORE_MODULE.SCORE_TYPES.VERYBAD;
    });
  }
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit() {
  }

  async close() {
    this.modalCtrl.dismiss(/*{someData: ...} */);
  }

  chooseItem(item: any) {
    this.modalCtrl.dismiss({
      stars: item.stars,
    });
  }

}
